<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
</style>

<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
           
            <FormItem :label="$t('BasicProduct.basicClassBox.name')" prop="className"  style="width: 500px">
                 <Input type="text" maxlength="20" v-model.trim="formData.className" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <!-- <FormItem :label="$t('deviceManage.manageModel.remark')" prop="receiverGroup"  style="width: 500px">
                 <Input  maxlength="100" show-word-limit type="textarea" v-model="formData.orderId" :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem> -->

            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import { mapState } from 'vuex'

    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            top_id:Number,
            editFormData:Object
        },
        name: "SModel3",
        components: {
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                    className: '',
                    parentClassId:''
                },
            }
        },
        watch:{
            showModel(val){
                if(val){
                    
                }
            },
        },
        computed:{
             ...mapState(['selectId']),
            ruleCustom(){//验证
                return {
                     className: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ]
                }   
            }
        },
        created(){
           
        },
        methods: {
            openOrClose(value) {
                if(value === true) {    
                    // this.title = this.type==1? this.$t('BasicProduct.basicClassBox.title'):this.$t('BasicProduct.basicClassBox.title1')
                   
                    this.title = (this.type==1? this.$t('BasicProduct.basicClassBox.title'):this.$t('BasicProduct.basicClassBox.title1'))

                    console.log('this.editFormData',this.editFormData);
                    if(!this.editFormData.id){//创建一级分类
                        this.title =this.title +'一级分类'
                    }else if(this.type==1){
                        this.title =this.title + '分类，所属分类：'+this.editFormData.className
                    }else{
                        this.title =this.title + '分类'
                    }
                    
                    this.formData.parentClassId = this.editFormData.id || 0
                    
                    if(this.type==2){
                        this.formData.className = this.editFormData.className
                    }
                } else { //关闭弹框后要做的处理
                    
                    this.resetForm();//重置表单
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                        let params = {...this.formData}
                        if(!params.parentClassId){
                            delete params.parentClassId
                        }

                        let url = this.config.urlArray.createBasicClasses
                        if(this.type==2){
                            params.id= this.editFormData.id
                            url = this.config.urlArray.modifyBasicClasses
                        }


                        this.axios.post(url,params).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.fn()
                                this.resetForm();//重置表单
                                this.cancel()
                            },()=>{
                                this.disabled = false; 
                            })
                            
                        }).catch((err) => {
                            // common.msg('error',this.$t('failed'),()=>{this.disabled = false;})
                            this.disabled = false;
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                // this.fn()
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.formData.parentClassId = '';//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>
